var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    _vm._b(
      {
        ref: "form",
        staticClass: "dpform",
        attrs: {
          size: _vm.$attrs["size"] ? _vm.$attrs["size"] : "mini",
          "label-position": _vm.$attrs["label-position"]
            ? _vm.$attrs["label-position"]
            : "right",
          model: _vm.model,
          rules: _vm.rules,
          "validate-on-rule-change": false,
        },
      },
      "el-form",
      _vm.$attrs,
      false
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }